export default __webpack_public_path__ + "static/media/carousel5.eab1bd9f.png";